import axios from 'axios';
class Api {
    baseUrl: string;

    constructor() {
       this.baseUrl = `${process.env.REACT_APP_BASE_URL}`;
    // this.baseUrl = 'http://localhost:3001/api/v1.0/'
    }

    async post(url: string, data: {}, headers: any = {}) {
        let token = localStorage.getItem('token');
        if (token != null){
            headers["token"] = `${token}`;
            headers['userid'] = '214801ae-7679-11eb-a99d-0284247dcb8a';
            headers['appname'] = 'SPOK';
            headers['txnid'] = sessionStorage.getItem('txnid');
        } 
        try {
            url = `${this.baseUrl}${url}`
            return await axios.post(url, data, { headers }).then((response: any)=>{
                console.log("resp  "+response)
                return response?.data;
            }).catch((error:any)=>{
                console.log(error);
                console.log(error.response.status);
                if(error.response.status == 504) {
                    return error.response;
                }
                return error.response.data;
            });
        } catch (e: any) {
            console.log(e); 
        }
    }
}

export default Api;

